import React, { useState } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { Button, useColorMode } from 'theme-ui';
import AddStageStepper from './AddStageStepper';

const AddStage: React.FC = () => {
    const [open, setIsOpen] = useState(false);
    const [step, setStep] = useState(0);
    const handleOpen = () => {
        setIsOpen(true)
    }
    const handleNext = () => {
        setStep(prevStep => prevStep + 1);
    };

    const handleBack = () => {
        setStep(prevStep => prevStep - 1);
    };
    const toggle = () => { setIsOpen(false); }
    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={toggle}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    return (
        <div>
            <Button variant="SaveButton" onClick={handleOpen}>Add Stage</Button>
            <Modal isOpen={open} size='xl' centered>
                <ModalHeader className='d-flex' close={closeButton} toggle={toggle} style={{ backgroundColor: modalHeader, color: titleHeader }}>Add Stage</ModalHeader>
                <AddStageStepper next={handleNext} />
            </Modal>
        </div>
    )
}

export default AddStage
